import React, { useEffect, useState } from 'react'
import { useCart } from "react-use-cart";
import { useHistory } from 'react-router-dom';
import { FormatRupiah } from './services/FormatRupiah';

const Cart = ({ emptyCart, onClose }) => {
  const history = useHistory()
  const [btnDisabled, setBtnDisabled] = useState(false);
  const {
    items,
    totalItems,
    cartTotal,
    updateItemQuantity,
  } = useCart();
  const [isMember, setIsMember] = useState(false)

  const checkoutCart = () => {
    let keranjang = []
    setBtnDisabled(true);
    for (let i = 0; i < items.length; i++) {
      keranjang.push({
        name: items[i].name_product,
        description: items[i].code_product,
        value: items[i].itemTotal,
        weight: 1000,
        quantity: items[i].quantity
      })
    }
    history.push({
      pathname: '/merchandise/checkout',
      state: {
        items: keranjang,
        items_real: items,
        cartTotal: cartTotal,
        isMember: isMember
      },
    })
    setBtnDisabled(false);
  }

  useEffect(() => {
    checkMember();
  }, [isMember])

  const checkMember = () => {
    items.filter(function (el) {
      if (el.is_with_member == 1) {
        setIsMember(true)
      }
    })
  }

  return (
    <>
      {/* Overlay */}
      <div className="cart-overlay" onClick={onClose} />

      {/* Sidebar */}
      <div className="cart-sidebar">
        {/* Header */}
        <div className="cart-sidebar-header">
          <div className="cart-sidebar-title">
            <i className="bi bi-bag-check" style={{ marginRight: 10 }}></i>
            Keranjang Belanja
            {totalItems > 0 && (
              <span className="cart-count-badge">{totalItems}</span>
            )}
          </div>
          <button className="cart-close-btn" onClick={onClose}>
            <i className="bi bi-x-lg"></i>
          </button>
        </div>

        {/* Body */}
        <div className="cart-sidebar-body">
          {items.length === 0 ? (
            <div className="cart-empty-state">
              <i className="bi bi-bag-x"></i>
              <p>Keranjang masih kosong</p>
            </div>
          ) : (
            items.map((prod) => (
              <div className="cart-item" key={prod.id}>
                {prod.file_pic && (
                  <img
                    src={prod.file_pic}
                    alt={prod.name_product}
                    className="cart-item-img"
                  />
                )}
                <div className="cart-item-info">
                  <p className="cart-item-name">{prod.name_product}</p>
                  <p className="cart-item-price">{FormatRupiah(prod.price)}</p>
                  {prod.is_with_member === 0 && (
                    <div className="cart-qty-control">
                      <button
                        className="cart-qty-btn"
                        onClick={() => updateItemQuantity(prod.id, prod.quantity - 1)}
                      >−</button>
                      <span className="cart-qty-value">{prod.quantity}</span>
                      <button
                        className="cart-qty-btn"
                        onClick={() => updateItemQuantity(prod.id, prod.quantity + 1)}
                      >+</button>
                    </div>
                  )}
                </div>
                <div className="cart-item-total">
                  {FormatRupiah(prod.itemTotal)}
                </div>
              </div>
            ))
          )}
        </div>

        {/* Footer */}
        {items.length > 0 && (
          <div className="cart-sidebar-footer">
            <div className="cart-total-row">
              <span>Total ({totalItems} Barang)</span>
              <strong>{FormatRupiah(cartTotal)}</strong>
            </div>
            <button
              className="cart-checkout-btn"
              disabled={btnDisabled}
              onClick={checkoutCart}
            >
              <i className="bi bi-credit-card" style={{ marginRight: 8 }}></i>
              {btnDisabled ? 'Memproses...' : 'Checkout Sekarang'}
            </button>
            <button className="cart-empty-btn" onClick={emptyCart}>
              <i className="bi bi-trash3" style={{ marginRight: 6 }}></i>
              Kosongkan Keranjang
            </button>
          </div>
        )}
      </div>

      <style>{`
        .cart-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.4);
          z-index: 1040;
          backdrop-filter: blur(3px);
          animation: fadeIn 0.3s ease;
        }
        .cart-sidebar {
          position: fixed;
          top: 0;
          right: 0;
          height: 100vh;
          width: 420px;
          max-width: 95vw;
          background: #fff;
          z-index: 1050;
          display: flex;
          flex-direction: column;
          box-shadow: -10px 0 40px rgba(0,0,0,0.12);
          animation: slideIn 0.35s cubic-bezier(0.22, 1, 0.36, 1);
        }
        @keyframes fadeIn { from { opacity:0 } to { opacity:1 } }
        @keyframes slideIn { from { transform: translateX(100%) } to { transform: translateX(0) } }

        /* Header */
        .cart-sidebar-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 24px 28px;
          border-bottom: 1px solid #f0f0f0;
        }
        .cart-sidebar-title {
          font-size: 18px;
          font-weight: 700;
          color: #111;
          display: flex;
          align-items: center;
        }
        .cart-count-badge {
          background: #e51d2a;
          color: #fff;
          border-radius: 50%;
          width: 22px;
          height: 22px;
          font-size: 12px;
          font-weight: 700;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          margin-left: 10px;
        }
        .cart-close-btn {
          background: #f5f5f5;
          border: none;
          border-radius: 8px;
          width: 38px;
          height: 38px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          font-size: 16px;
          color: #333;
          transition: background 0.2s;
        }
        .cart-close-btn:hover { background: #ebebeb; }

        /* Body */
        .cart-sidebar-body {
          flex: 1;
          overflow-y: auto;
          padding: 20px 28px;
        }
        .cart-empty-state {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 100%;
          color: #bbb;
          gap: 12px;
        }
        .cart-empty-state i {
          font-size: 64px;
        }
        .cart-empty-state p {
          font-size: 16px;
          font-weight: 500;
          margin: 0;
        }

        /* Item */
        .cart-item {
          display: flex;
          align-items: flex-start;
          gap: 16px;
          padding: 18px 0;
          border-bottom: 1px solid #f5f5f5;
        }
        .cart-item-img {
          width: 70px;
          height: 70px;
          object-fit: cover;
          border-radius: 10px;
          flex-shrink: 0;
          border: 1px solid #eee;
        }
        .cart-item-info {
          flex: 1;
        }
        .cart-item-name {
          font-size: 14px;
          font-weight: 600;
          color: #111;
          margin-bottom: 4px;
        }
        .cart-item-price {
          font-size: 13px;
          color: #888;
          margin-bottom: 10px;
        }
        .cart-qty-control {
          display: flex;
          align-items: center;
          gap: 0;
          border: 1px solid #eee;
          border-radius: 8px;
          overflow: hidden;
          width: fit-content;
        }
        .cart-qty-btn {
          background: #f8f8f8;
          border: none;
          width: 32px;
          height: 32px;
          font-size: 18px;
          cursor: pointer;
          color: #333;
          transition: background 0.2s;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .cart-qty-btn:hover { background: #eee; }
        .cart-qty-value {
          width: 36px;
          text-align: center;
          font-size: 14px;
          font-weight: 600;
          color: #111;
          border-left: 1px solid #eee;
          border-right: 1px solid #eee;
        }
        .cart-item-total {
          font-size: 14px;
          font-weight: 700;
          color: #111;
          white-space: nowrap;
          flex-shrink: 0;
        }

        /* Footer */
        .cart-sidebar-footer {
          padding: 24px 28px;
          border-top: 1px solid #f0f0f0;
          background: #fff;
        }
        .cart-total-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 15px;
          margin-bottom: 18px;
          color: #333;
        }
        .cart-total-row strong {
          font-size: 20px;
          font-weight: 800;
          color: #e51d2a;
        }
        .cart-checkout-btn {
          width: 100%;
          background: #e51d2a;
          color: #fff;
          border: none;
          border-radius: 10px;
          padding: 15px;
          font-size: 15px;
          font-weight: 700;
          cursor: pointer;
          transition: background 0.3s;
          margin-bottom: 10px;
        }
        .cart-checkout-btn:hover { background: #c91823; }
        .cart-checkout-btn:disabled { opacity: 0.6; cursor: not-allowed; }
        .cart-empty-btn {
          width: 100%;
          background: transparent;
          color: #999;
          border: 1px solid #eee;
          border-radius: 10px;
          padding: 11px;
          font-size: 14px;
          cursor: pointer;
          transition: all 0.2s;
        }
        .cart-empty-btn:hover { border-color: #e51d2a; color: #e51d2a; }
      `}</style>
    </>
  )
}

export default Cart